














































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import AntecipacaoRecebiveisStore from '../../financeiro/Store/AntecipacaoRecebiveisStore'
import { E } from '@fullcalendar/resource/internal-common'
import EventBus from '@/plugins/EventBus'

@Component
export default class AntecipacaoForm extends Vue {
  tab: string = 'antecipacao'
  menuData: boolean = false
  tipoContaSelecionada: string = 'CNPJ'
  idContaSelecionada: string = ''

  tiposConta = [
    { text: 'Conta PF', value: 'CPF' },
    { text: 'Conta PJ', value: 'CNPJ' }
  ]

  get antecipacao() {
    return this.antecipacaoRecebiveisStore.antecipacaoById
  }

  set antecipacao(value: any) {
    this.antecipacaoRecebiveisStore.setAntecipacaoById(value)
  }

  get listaDadosBancarios() {
    return this.antecipacaoRecebiveisStore.dadosBancarios
  }

  get dadosBancarios() {
    return this.antecipacaoRecebiveisStore.dadosBancariosSelecionado
  }

  set dadosBancarios(value: any) {
    this.antecipacaoRecebiveisStore.setDadosBancariosSelecionado(value)
  }

  get situacoes() {
    return this.antecipacaoRecebiveisStore.situacoes
  }

  get bancos() {
    return this.antecipacaoRecebiveisStore.bancos
  }

  get tiposPix() {
    return this.antecipacaoRecebiveisStore.tiposPix
  }

  get antecipacaoRecebiveisStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get showModal(): boolean {
    return this.antecipacaoRecebiveisStore.modalAntecipacaoForm
  }

  set showModal(value: boolean) {
    this.antecipacaoRecebiveisStore.setModalAntecipacaoForm(value)
  }

  get formattedDate(): string {
    return this.antecipacao.proximoPagamento ? moment(this.antecipacao.proximoPagamento).format('DD/MM/YYYY') : ''
  }

  get opcoesContas() {
    const lista = Array.isArray(this.listaDadosBancarios) ? this.listaDadosBancarios : []
    return lista.map((d: any) => ({
      id: d.dadoBancarioId,
      label: d.padrao ? 'Conta Padrão (Principal)' : 'Conta Secundária'
    }))
  }

  formBancarios: any = {
    valid: true,
    codigoBanco: [(v: string) => !!v || 'Código obrigatório'],
    nomeBanco: [(v: string) => !!v || 'Nome obrigatório'],
    agencia: [(v: string) => !!v || 'Agência obrigatória'],
    digitoAgencia: [(v: string) => !!v || 'Dígito obrigatório'],
    conta: [(v: string) => !!v || 'Conta obrigatória'],
    digitoConta: [(v: string) => !!v || 'Dígito obrigatório'],
    tipoChavePix: [(v: string) => !!v || 'Tipo de Chave PIX obrigatório'],
    chavePix: [
      (v: string) => !!v || 'Chave PIX obrigatória'],
  }

  carregarDadosPorId() {
    const selecionado = this.listaDadosBancarios.find(
      (d: any) => d.dadoBancarioId === this.idContaSelecionada
    )
    if (selecionado) {
      this.preencherFormulario(selecionado)
    }
  }

  carregarDadosBancarios() {
    const lista = Array.isArray(this.listaDadosBancarios) ? this.listaDadosBancarios : []
    
    const padrao = lista.find((d: any) => d.padrao === true)
    
    if (padrao) {
      this.idContaSelecionada = padrao.dadoBancarioId
      this.preencherFormulario(padrao)
    }
  }

  preencherFormulario(dados: any) {
    this.dadosBancarios = {
      dadoBancarioId: dados.dadoBancarioId,
      codigoBanco: dados.instuicaoFinanceira.codigoBanco || '',
      instituicaoFinanceiraId: dados.instuicaoFinanceira.instuicaoFinanceiraId || null,
      nomeBanco: dados.instuicaoFinanceira.nome || '',
      agencia: dados.agencia,
      digitoAgencia: dados.digitoAgencia,
      conta: dados.conta,
      digitoConta: dados.digitoConta,
      tipoChavePix: dados.tipoChavePix,
      chavePix: dados.chavePix,
      pessoaId: dados.pessoaId || null
    }
  }

  formatMoney(value: number): string {
    if (value === null || value === undefined) return ''
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  }

  async atualizar() {
    if (this.tab === 'antecipacao') {
      this.tab = 'bancarios'
    } else if (this.tab === 'bancarios') {
      const request = await this.antecipacaoRecebiveisStore.atualizarAntecipacao()
      if (request.success) {
        this.showModal = false
        EventBus.$emit('setSnackbar', { show: true, text: 'Antecipação atualizada com sucesso.', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao atualizar a antecipação.', icon: 'error', color: '#C62828' })
      }
    }
  }

  @Watch('showModal')
  onShowModalChange(val: boolean) {
    if (!val) {
      this.tab = 'antecipacao'
      this.antecipacaoRecebiveisStore.setAntecipacaoById({})
      this.antecipacaoRecebiveisStore.setDadosBancariosSelecionado({})
      this.idContaSelecionada = ''
      this.formBancarios.valid = true
    }
    if (val) {
      this.carregarDadosBancarios()
    }
  }
}
